import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';
import { hasYesOrNo } from 'models/validate';
import { LegalAssociationsEventItemModel } from '../../eventItem/types';

export const legalAssociationsViolentActsItemValidator: ValidateJSModel<LegalAssociationsEventItemModel> = {
  Why: { presence: true, hasValue: true },
  When: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options.applicantBirthdate), latest: DEFAULT_LATEST },
  }),
  What: { presence: true, hasValue: true },
};

export const legalAssociationsViolentActsItemWithWasValidator: ValidateJSModel<LegalAssociationsEventItemModel> = {
  Was: { presence: true, hasValue: { validator: hasYesOrNo } },
  Why: { presence: true, hasValue: true },
  When: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options.applicantBirthdate), latest: DEFAULT_LATEST },
  }),
  What: { presence: true, hasValue: true },
};
